import {
  BookLessonContentDocument,
  BookLessonSummariesDocument,
  BookSeriesListDocument,
} from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

export function useBookSeries() {
  const { data, loading, error } = useQuery(BookSeriesListDocument, {
    fetchPolicy: "cache-first",
  });
  return { series: data?.bookSeries ?? [], loading, error };
}

/** Every lesson of one series, carrying only the counts the generator shows. */
export function useBookLessonSummaries(seriesSlug: string | null) {
  const { data, loading, error } = useQuery(BookLessonSummariesDocument, {
    variables: { seriesSlug: seriesSlug ?? "" },
    skip: seriesSlug === null,
    fetchPolicy: "cache-first",
  });
  return { bookLessons: data?.bookLessons ?? [], loading, error };
}

export function useBookLessonContent(bookLessonId: string | null) {
  const { data, loading } = useQuery(BookLessonContentDocument, {
    variables: { id: bookLessonId ?? "" },
    skip: bookLessonId === null,
    fetchPolicy: "cache-first",
  });

  const lesson = data?.bookLesson ?? null;
  return {
    rows: lesson?.rows ?? [],
    pageLines: lesson?.pageLines ?? [],
    loading,
  };
}
